'use strict';
var parent = require('../../stable/symbol/to-primitive');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/symbol/to-primitive.js
// module id = 553
// module chunks = 13